import { useState } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { Button, ErrorNotice } from '../components/ui'

export function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<unknown>(null)
  const [busy, setBusy] = useState(false)

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await signIn(email.trim(), password)
      // The router swaps to the app as soon as `me` reports a user.
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-600 text-lg font-bold text-white">
            A
          </span>
          <h1 className="mt-3 text-xl font-semibold tracking-tight">APO Atlas</h1>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Sign in to see what you owe and when.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card space-y-4 p-6">
          <div>
            <label className="label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="field"
              autoComplete="username"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="field"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error != null && <ErrorNotice error={error} />}

          <Button type="submit" variant="primary" loading={busy} className="w-full">
            Sign in
          </Button>

          <p className="text-center text-xs text-slate-500 dark:text-slate-400">
            Accounts are created by your administrator. If you have forgotten your password, ask them
            to reset it. There is no reset email.
          </p>
        </form>
      </div>
    </div>
  )
}
